import React from 'react';
import {Helmet} from 'react-helmet';
import intl from 'react-intl-universal';


const TermsOfService = () => (
  <div className='container'>
    <Helmet>
      <title>{intl.get('Terms of Service | ImageResize.org')}</title>
    </Helmet>
    {/* <ReactMarkdown className='section' source={termsOfService} /> */}
    <div class="section">
      <h1>{intl.get('TermsOfService.Header')}</h1>
      <p>
        {intl.get('TermsOfService.Para1')}
        <a href="/privacy">{intl.get('TermsOfService.PrivacyPolicy')}</a>.
        {intl.get('TermsOfService.Para2')}
      </p>
      <h3>{intl.get('TermsOfService.EntireAgreement')}</h3>
      <p>{intl.get('TermsOfService.EntireAgreementPara')}</p>
      <h3>{intl.get('TermsOfService.NoUnlawfulOrProhibitedUse')}</h3>
      <p>{intl.get('TermsOfService.NoUnlawfulOrProhibitedUsePara')}</p>
      <h3>{intl.get('TermsOfService.LinksDisclaimer')}</h3>
      <p><strong>{intl.get('TermsOfService.LinksDisclaimerPara')}</strong></p>
      <h3>{intl.get('TermsOfService.Termination/AccessRestriction')}</h3>
      <p>{intl.get('TermsOfService.Termination/AccessRestrictionPara')}</p>
      <h3>{intl.get('TermsOfService.Disclaimer')}</h3>
      <p>{intl.get('TermsOfService.DisclaimerPara')}</p>
      <h3>{intl.get('TermsOfService.LimitationOfLiability')}</h3>
      <p>{intl.get('TermsOfService.LimitationOfLiabilityPara')}</p>
      <h3>{intl.get('TermsOfService.ApplicableLaw')}</h3>
      <p>{intl.get('TermsOfService.ApplicableLawPara')}</p>
      <h3>{intl.get('TermsOfService.Copyright')}</h3>
      <p>{intl.get('TermsOfService.CopyrightPara')}</p>
      <h3>{intl.get('TermsOfService.MaterialConnectionDisclosure')}</h3>
      <p>{intl.get('TermsOfService.MaterialConnectionDisclosurePara')}</p>
      <p>
        <strong>{intl.get('TermsOfService.ServiceContact')}</strong>
        <a href="mailto:imageresize.org@gmail.com">{intl.get('TermsOfService.Imageresize.org@gmail.com')}</a>
      </p>
    </div>
  </div>
);

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/containers/TermsOfService/index.jsx